// Import modules
import mobileMenu from './modules/mobile-menu.js';
import modal from './modules/modal.js';
import notification from './modules/notification.js';
import Swiper from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import equalheight from "./modules/equalheights";
import Lenis from '@studio-freight/lenis';
import wordLooper from "./modules/wordLooper";
import counter from "./modules/counter";

const small 	    = Modernizr.mq('only screen and (max-width: 363px)')
const mobile 	    = Modernizr.mq('only screen and (min-width: 320px) and (max-width: 720px)')
const tablet 	    = Modernizr.mq('only screen and (min-width: 721px) and (max-width: 992px)')
const laptop 	    = Modernizr.mq('only screen and (min-width: 993px) and (max-width: 1024px)')
const desktop     = Modernizr.mq('only screen and (min-width: 1025px) and (max-width: 1199px)')
const large 	    = Modernizr.mq('only screen and (min-width: 1200px)')

// Init functions
function init() {

	// do smoothscroll
	const lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: 'vertical', // vertical, horizontal
		gestureDirection: 'vertical', // vertical, horizontal, both
		smooth: true,
		mouseMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false
	})

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf)

	// init fancybox
	Fancybox.bind('[data-fancybox]');

	// init mobile menu --> wp-content/themes/expl-theme/source/scripts/modules/mobile-menu.js
	mobileMenu()

	// init modal --> wp-content/themes/expl-theme/source/scripts/modules/modal.js
	modal()

	// init notification --> wp-content/themes/expl-theme/source/scripts/modules/notification.js
	// init notification popup
	document.querySelector('.notification-popup') &&
		notification('.notification-popup', 'notification-popup', 1000)

	// init notification snackbar
	document.querySelector('.notification-snackbar') &&
		notification('.notification-snackbar', 'notification-snackbar', 2000)

	//Word looper --> wp-content/themes/expl-theme/source/scripts/modules/wordLooper.js
	if (document.querySelector('.site-header .word-wrapper') !== null) {
		wordLooper()

		const internalLink = document.querySelector('.word-wrapper');
		internalLink.addEventListener('click', (event) => {
			event.preventDefault()
			let targetDiv = internalLink.getAttribute('href')
			lenis.scrollTo(targetDiv)
		})
	}

	// equalheight --> wp-content/themes/expl-theme/source/scripts/modules/equalheights.js
	// make title equal height on blog includes
	if (document.querySelector('.subsites') !== null) {
		if (laptop || desktop || large) {
			equalheight('.subsites .content-wrapper')
		}
	}
	if (document.querySelector('.addresses') !== null) {
		if (laptop || desktop || large) {
			equalheight('.addresses address')
		}
	}

	// Counters --> wp-content/themes/expl-theme/source/scripts/modules/counter.js
	if (document.querySelector('.numbers-wrapper') !== null) {
		counter()
	}
}

// Run the init function when the page loads
window.onload = init;
